module.exports = __webpack_public_path__ + "assets/img/ic-export-title.660d7a20.svg";